import { useTranslation } from 'react-i18next';
import { KoobTableAction } from '@koob/ui';

const FoldersBookingEditButton = ({ bookingId, testId }) => {
  const { t } = useTranslation();

  return (
    <KoobTableAction
      icon="edit"
      label={t('misc:edit')}
      to={`/bookings/${bookingId}`}
      data-testid={testId}
    />
  );
};

export default FoldersBookingEditButton;
